import React from "react";
import LogoSign from "@assets/pngs/sign_logo.png";
import styles from "./styles/AuthFooter.module.css";

const AuthFooter = () => {
  return (
    <div className={styles.footer}>
      <img src={LogoSign} alt="" />
      <span>
        © 2022 <strong>Cursus</strong>. All Rights Reserved.
      </span>
    </div>
  );
};

/* required: display name */
AuthFooter.displayName = "AuthFooter";

/* required: props types */
AuthFooter.propTypes = {};

/* required: default props */
AuthFooter.defaultProps = {};

export { AuthFooter };
